import React from 'react'

const Remerciements = () => {
  return (
    <div>
      <p>
        Merci à : Mick, Cédric, Rodolphe, Stu, Chimène, Adèle, Téo
        La Blaiserie, la commune de Biard, ses employés des services techniques,
        Grand Poitiers, Le conseil départemental de la Vienne.
      </p>
      <p>Merci à tous les bénévoles.</p>
      <p>
        Le festival reçoit le soutien de nombreux partenaires de la commune et
        alentours
      </p>
      <p>
        Le festival fait partie de Vienne Fest, Collectif des festivals de la
        Vienne
      </p>
    </div>
  )
}

export default Remerciements
